



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

// Component
import * as DownloadCsv from 'vue-json-csv'

@Component({
  components: { DownloadCsv },
  computed: {
    ...mapGetters('cards', {
      canEdit: 'canEdit',
    }),
  },
})
export default class ActionButtonsGroup extends Vue {
  canEdit!: () => boolean

  @Prop()
  csvData!: any

  @Prop()
  csvFields!: string[]

  @Prop({ default: 'undefinedTitle.csv' })
  csvFileName!: string

  @Prop()
  onOpenFormModal!: () => void

  @Prop()
  onOpenImportCSV!: () => void
}
